import { render } from "./OTPAuth.vue?vue&type=template&id=40d4e46a&scoped=true"
import script from "./OTPAuth.vue?vue&type=script&lang=js"
export * from "./OTPAuth.vue?vue&type=script&lang=js"

import "./OTPAuth.vue?vue&type=style&index=0&id=40d4e46a&lang=sass&scoped=true"

import exportComponent from "../../../../../../../opt/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40d4e46a"]])

export default __exports__